const ScreenSize = {
  xs: "360px", // Mobile devices
  sm: "768px", // Tablets
  md: "1024px", // Small Screens
  lg: "1440px", // Desktops
};

export default ScreenSize;
